import { render } from "./AddNewCompany.vue?vue&type=template&id=64e99c3c"
import script from "./AddNewCompany.vue?vue&type=script&lang=js"
export * from "./AddNewCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__